import { render, staticRenderFns } from "./stuform.vue?vue&type=template&id=d60c8ec2&scoped=true"
import script from "./stuform.vue?vue&type=script&lang=js"
export * from "./stuform.vue?vue&type=script&lang=js"
import style0 from "./stuform.vue?vue&type=style&index=0&id=d60c8ec2&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60c8ec2",
  null
  
)

export default component.exports